export interface ListParams {
  page: number
  page_size: number
}

export interface BrandParams {
  model_type?: number
  resource_type?: number
  media_type?: number
  is_template?: number
}

export interface ChangeBrandParams {
  brand_ids?: number[]
  brand_guidelines?: 'True' | 'False'
}

export interface BrandItem {
  id: number
  model_id: number
  model_type: number
  resource_type: number
  media_type: number
  name: string
  cover_url: string
  file_url: string
  user_id: number
  username: string
  brand_guidelines: boolean
  last_generate_record_data: {
    generate_record_id?: number
    segment_log_id?: number
    camera_log_id?: number
    video_packaging_log_id?: number
  }
  create_time: string
  update_time: string
}

export interface UpdateBrandStatusRequest {
  status: 0 | 1
  msg_id: number
}

export interface UpdateBrand {
  id: number
  name: string
}

export enum FOLLOW_STATUS {
  NONE = -2, // 未认证
  FOLLOW = -1, // 没发起申请
  FOLLOWED = 0, // 已跟随
  REFUSE = 1, // 拒绝
  FOLLOWING = 2, // 申请中
}

export interface Following {
  status: FOLLOW_STATUS
  from_org_id: number
  from_org_name: string
  to_org_name: string
  accept_org_name: string
  to_user_name: string
  to_user_id: number
}

export interface ToFollow {
  to_user_id: number
  to_org_id: number
  to_user_name: string
  to_org_name: string
}

export interface FollowTeam {
  /**
   * 超管名称
   */
  name: string
  /**
   * 团队id
   */
  organization_id: number
  /**
   * 团队名称
   */
  organization_name: string
  /**
   * 超管user_id
   */
  user_id: number
  create_time: string
}
